import { fetchMessageById } from '@app/api'

import { MessageDetails } from '../types'

export const fetchMessageDetailsSafely = async (
  conversationId: number,
  messageId: number,
  fallbackText: string,
  source: 'Chat' | 'Email' | 'System',
  isTranslationEnabled: boolean
): Promise<MessageDetails> => {
  const controller = new AbortController()
  let translations: MessageDetails['translations']
  let messageContent = fallbackText
  let messageLanguage: MessageDetails['content']['language']
  let messageAttachments: MessageDetails['attachments']
  let systemNotificationType: MessageDetails['systemNotificationType']
  let recipientParticipantId: MessageDetails['recipientParticipantId']
  let buyerOrRenterParticipantId: MessageDetails['buyerOrRenterParticipantId']
  let callerParticipantId: MessageDetails['callerParticipantId']
  let toParticipantId: MessageDetails['toParticipantId']
  let fromParticipantId: MessageDetails['fromParticipantId']

  try {
    const { message } = await fetchMessageById(
      conversationId,
      messageId,
      controller.signal
    )
    translations = message.translations
    messageContent = message.content?.text || fallbackText
    messageLanguage = message.content?.language
    messageAttachments = message.attachments
    systemNotificationType = message.systemNotificationType
    recipientParticipantId = message.recipientParticipantId
    buyerOrRenterParticipantId = message.buyerOrRenterParticipantId
    callerParticipantId = message.callerParticipantId
    toParticipantId = message.toParticipantId
    fromParticipantId = message.fromParticipantId
  } catch (error) {
    if (source === 'Email' || isTranslationEnabled) {
      console.error('Failed to fetch detailed message data', error)
    }
  }

  return {
    translations,
    content: {
      text: messageContent,
      language: messageLanguage,
    },
    attachments: messageAttachments,
    systemNotificationType,
    recipientParticipantId,
    buyerOrRenterParticipantId,
    callerParticipantId,
    toParticipantId,
    fromParticipantId,
  }
}
